import { ISearchResult } from '../../state-helpers/search-results';
import * as React from 'react';
import * as Moment from 'moment';
import * as Redux from 'redux';
import { IState } from '../../reducers/index';

export interface ISearchResultProps {
  result: ISearchResult;
  dispatch: Redux.Dispatch<IState>;
}

export interface ISearchResultTemplateProps extends ISearchResultProps {
}

var htmlEncode = function (stringToEncode) {
  return { __html: stringToEncode };
}

export class SearchResult extends React.Component<ISearchResultProps, any> {
  render() {
    var searchResultTemplate;
    searchResultTemplate = <SearchResultGeneral result={this.props.result} dispatch={this.props.dispatch} />;
    return (
      <li className="search-result-item-wrapper">
        {searchResultTemplate}
      </li>
    )
  }
}

export class SearchResultGeneral extends React.Component<ISearchResultTemplateProps, any>{
    render() {
    return (
      <a className="search-result-item" href={this.props.result.url} target="_blank">
        <h4 className="search-result-title" dangerouslySetInnerHTML={htmlEncode(this.props.result.title)}></h4>
          
        <div className="search-result-permalink">
                {<u>
                    {!this.props.result.viewableByEveryone &&
                        <span className="members-only-indicator">
                            <svg className="svg-icon" aria-hidden="true" focusable="false">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-lock" />
                            </svg>
                            <span className="visually-hidden">Accessible to Members Only</span>
                        </span>
                    }
                    
					{this.props.result.friendlyUrl}
				</u>}
        </div> 

        {this.props.result.revisedDate &&
          <p className='search-result-excerpt-date'>{this.props.result.revisedDate}</p>
        }
        { this.props.result.shortDescription &&
          <p className="search-result-content" dangerouslySetInnerHTML={{ __html: this.props.result.shortDescription }}></p>
        }
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/components/search-results/search-result.tsx